import React from "react";
import { Box, Text, useColorModeValue } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import FieldFrame from "./FieldFrame";

const ReadOnlyField = ({ field, control, error, required, compact }) => {
  const bg = useColorModeValue("gray.50", "gray.700");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  return (
    <Controller
      control={control}
      name={field.code}
      render={({ field: input }) => (
        <FieldFrame field={field} error={error} isRequired={required} compact={compact}>
          <Box bg={bg} borderWidth="1px" borderColor={borderColor} borderRadius="md" px={3} py={2} minH="40px">
            <Text fontWeight={compact ? "semibold" : "medium"}>{input.value ?? field.defaultValue ?? "—"}</Text>
          </Box>
        </FieldFrame>
      )}
    />
  );
};

export default ReadOnlyField;
